import { catchError, map, tap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from '../fgi-back-end.service';

@Injectable({ 
  providedIn: 'root'
}) 
export class AmbienteService extends FgiBackEndService<any> {

   // @Override
   getNewEntity() {
    // o servico sera apenas para leitura
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/ambiente';
  }

  public isPRD(): Observable<boolean> {
    return this.buscarAmbienteExecucao().pipe(
      map(ambiente => ambiente === 'PRD'));
  }

  public buscarAmbienteExecucao(): Observable<string> {
    return this.http.get(`${this.BASE_URL}`, { responseType: 'text' }).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }
}